import { useState, useEffect } from "react";
import { ChevronUp, LifeBuoy, Mail, Clock } from "lucide-react";

const faqs = [
  {
    question: "Why don't the results match my own Google search?",
    answer:
      "Google shows different results depending on location, device and search history, and changes them often. The app searches from the city you pick, with no personal history.",
  },
  {
    question: "Why isn't a business I know advertises listed?",
    answer:
      "The app only lists businesses it could confirm are advertising. If we couldn't find a business's website, or the check didn't finish in time, it's left out rather than shown as not advertising.",
  },
  {
    question: "How do I change or cancel a call I booked?",
    answer: "Use the link in your Cal.com confirmation email.",
  },
  {
    question: "Is this app made by Google?",
    answer: "No. Who's Ranking on G is not affiliated with Google.",
  },
];

const WhosRankingSupport = () => {
  const [showBackToTop, setShowBackToTop] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setShowBackToTop(window.scrollY > 400);
    };
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <div className="pp-page" data-testid="whosranking-support-page">
      <main className="pp-main" data-testid="whosranking-support-content">
        <article className="pp-article">
          <header className="pp-header" data-testid="whosranking-support-header">
            <div className="pp-header-icon">
              <LifeBuoy size={28} strokeWidth={1.5} />
            </div>
            <h1 className="pp-title">Support — Who's Ranking on G</h1>
            <p className="pp-last-updated">We reply within 2 business days</p>
          </header>

          <section className="pp-section" data-testid="section-wrs-contact">
            <div className="pp-highlight-box">
              <p>
                Need help with Who's Ranking on G, or have feedback or an idea? Get in touch:
              </p>
            </div>
            <div className="pp-contact-card" data-testid="wrs-contact-card">
              <a
                href="mailto:support@radships.com"
                className="pp-contact-email"
                data-testid="wrs-contact-email"
              >
                <Mail size={16} />
                support@radships.com
              </a>
              <p className="pp-contact-name" style={{ marginTop: "0.75rem" }}>
                <Clock size={14} style={{ verticalAlign: "-2px", marginRight: "6px" }} />
                We reply within 2 business days.
              </p>
            </div>
          </section>

          <section className="pp-section" data-testid="section-wrs-faq">
            <h2 className="pp-section-heading">Common questions</h2>
            {faqs.map((faq, i) => (
              <div
                key={i}
                className="pp-faq-item"
                data-testid={`wrs-faq-${i}`}
                style={{ marginBottom: "1.25rem" }}
              >
                <h3 className="pp-subsection-heading">{faq.question}</h3>
                <p>{faq.answer}</p>
              </div>
            ))}

            <div className="pp-faq-item" data-testid="wrs-faq-delete">
              <h3 className="pp-subsection-heading">How do I delete my details?</h3>
              <p>
                Email us at{" "}
                <a
                  href="mailto:support@radships.com"
                  className="pp-link"
                  data-testid="wrs-delete-email"
                >
                  support@radships.com
                </a>{" "}
                and we'll delete them. See our{" "}
                <a
                  href="/whosrankingong/privacy"
                  className="pp-link"
                  data-testid="wrs-privacy-link"
                >
                  Privacy Policy
                </a>{" "}
                for everything we collect.
              </p>
            </div>
          </section>

          <footer className="pp-footer" data-testid="whosranking-support-footer">
            <p>&copy; {new Date().getFullYear()} Radhesh Gowd. All rights reserved.</p>
          </footer>
        </article>
      </main>

      {showBackToTop && (
        <button
          onClick={scrollToTop}
          className="pp-back-to-top"
          aria-label="Back to top"
          data-testid="wrs-back-to-top"
        >
          <ChevronUp size={20} />
        </button>
      )}
    </div>
  );
};

export default WhosRankingSupport;
